import "./App.css";
import WeatherApp from "./components/weatherApp/WeatherApp";

function App() {
	return (
		<div className="App">
			<WeatherApp />
		</div>
	);
}

export default App;
